module.exports = __webpack_public_path__ + "static/media/gold-star.644c2b12.png";